import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

const INVALID_DDD_LIST = [23, 25, 26, 29, 30, 36, 39, 40, 52, 56, 57, 58, 59, 72, 76, 78, 80];

export function celularValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const digits = String(control.value).replace(/\D/g, '');
  if (digits.length === 0) {
    return null;
  }

  if (digits.length !== 11) {
    return { message: 'Telefone inválido. Revise e tente novamente.' };
  }

  const ddd = Number(digits.substring(0, 2));
  if (INVALID_DDD_LIST.includes(ddd) || ddd < 11 || ddd > 99 || ddd % 10 === 0) {
    return { message: 'Telefone inválido. Revise e tente novamente.' };
  }

  if (digits.charAt(2) !== '9') {
    return { message: 'O número de celular deve começar com 9 após o DDD.' };
  }

  return null;
}

@Directive({
  selector: '[appCelularValidator]',
  providers: [
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CelularValidatorDirective),
    },
  ],
})
export class CelularValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return celularValidator(control);
  }
}
